import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { oktaAuthApiRef } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

const oktaSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { SignInPage } = await import('@backstage/core-components');
      return props => (
        <SignInPage
          {...props}
          auto
          provider={{
            id: 'okta-auth-provider',
            title: 'Okta',
            message: 'Sign in using Okta',
            apiRef: oktaAuthApiRef,
          }}
        />
      );
    },
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oktaSignInPage],
});
